import $ from 'jquery';

$.addInit(function(context){
	var base = '.b-subInfo';
	$(base, context).each(function(){
		var component = $(this);
	});
});